const schema = [
  {
    name: 'mdm-activity-logs',
    displayName: 'MDM Activity Log',
    systemIdField: null,
    displayIdField: 'id',
    path: '/mdm-activity-logs',
    deletable: false,
    readOnly: true,
    fields: [
      {
        name: 'id',
        displayName: 'ID',
        dataType: 'integer',
        systemIdentifier: true,
        hidden: true,
      },
      {
        name: 'operation',
        displayName: 'Operation',
        dataType: 'shorttext',
        searchable: true,
        filterable: true,
      },
   
      {
        name: 'edit_date',
        displayName: 'Edit Date',
        dataType: 'shorttext',
        searchable: true,
      },
      {
        name: 'edited_by',
        displayName: 'Edited By',
        dataType: 'shorttext',
        searchable: true,
        filterable: true,
      },
      {
        name: 'edit_from',
        displayName: 'Edit From',
        dataType: 'shorttext',
        searchable: true,
      },
      {
        name: 'entity',
        displayName: 'Entity',
        dataType: 'shorttext',
        searchable: true,
        filterable: true,
      },
      {
        name: 'entity_id',
        displayName: 'Entity ID',
        dataType: 'shorttext',
        searchable: true,
      },
      {
        name: 'field',
        displayName: 'Field',
        dataType: 'shorttext',
        searchable: true,
        filterable: true,
      },
      {
        name: 'edited_from',
        displayName: 'From',
        dataType: 'longtext',
        searchable: true,
      },
      {
        name: 'edited_to',
        displayName: 'To',
        dataType: 'longtext',
        searchable: true,
      },
      {
        name: 'modified',
        displayName: 'Modified',
        dataType: 'shorttext',
        hideList: true,
      },
      {
        name: 'meta',
        displayName: 'Meta',
        dataType: 'longtext',
        hideList: false,
      },
    ],
  },
];

export default schema;
